const APIUserAccountRequest = {};

// GET Requests

APIUserAccountRequest["getAllUserRoles"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/user-role', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIUserAccountRequest["getUserRoleById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/user-role/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIUserAccountRequest["getAllUsers"] = async (accessToken) => {
	try {
		const response = await fetch('/api/users/management', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIUserAccountRequest["getUsersByRegionId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/users/management/region/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIUserAccountRequest["getUsersByProvinceId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/users/management/province/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIUserAccountRequest["getUserById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/users/management/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIUserAccountRequest["getAllUsersByRoleId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/users/management/role/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

// POST Request

APIUserAccountRequest["submitUserRegistration"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/users/management', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

// PATCH Request

APIUserAccountRequest["editUserRegistration"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/users/management/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

export default APIUserAccountRequest
